<template>
  <div class="dashboard-nav-menu">
    <el-scrollbar
      class="nav-menu-scrollbar"
      style="width:100%;"
      inverse>
      <el-menu
        ref="menu"
        :value="getActiveNavMenuItemId"
        :unique-opened="true"
        background="nav-primary">

        <el-menu-item
          v-if="getActiveVolumeSubscription"
          :disabled="isDisabled"
          @click="onItemClick"
          index="MACHINES">
          <el-icon
            slot="icon"
            name="i-clone-o--32"/>
          <span slot="title">{{ $t('wre-dashboard.nav-menu.item.machines') | uppercase }}</span>
        </el-menu-item>

        <el-menu-item
          v-if="!getActiveVolumeSubscription"
          :disabled="isDisabled"
          @click="onItemClick"
          index="BACKUPS">
          <el-icon
            slot="icon"
            name="i-clone-o--32"/>
          <span slot="title">{{ $t('wre-dashboard.nav-menu.item.backups') | uppercase }}</span>
        </el-menu-item>

        <el-menu-item
          :disabled="isDisabled"
          @click="onItemClick"
          index="shared">
          <el-icon
            slot="icon"
            name="i-share-o--32"/>
          <span slot="title">{{ $t('wre-dashboard.nav-menu.item.shared') | uppercase }}</span>
        </el-menu-item>

        <el-menu-item
          @click="onItemClick"
          index="account">
          <el-icon
            slot="icon"
            name="i-user-o--32"/>
          <span slot="title">{{ $t('wre-dashboard.nav-menu.item.account') | uppercase }}</span>
        </el-menu-item>

      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapGetters } = createNamespacedHelpers('wre-dashboard');

export default {
  name: 'DashboardNavMenu',
  data() {
    return {
      isActiveVolumeSubscription: false
    };
  },
  computed: {
    ...mapGetters([
      'getActiveNavMenuItemId',
      'getUserSubscriptionType',
      'getActiveVolumeSubscription'
    ]),
    isDisabled() {
      return false;
      // return this.getUserSubscriptionType !== 'ACTIVE';
    }
  },
  methods: {
    onItemClick(menuItem) {
      if (!menuItem.disabled) {
        const action = this.getMenuEventActionName(menuItem.index);

        this.$gtm.push({
          event: 'Acronis',
          eventCategory: 'WRE_menu',
          eventAction: action,
          eventLabel: ''
        });

        this.handleSelect(menuItem.index);
      }
    },
    handleSelect(key) {
      this.$emit('navMenuItemSelected', {
        id: key
      });
    },
    getMenuEventActionName(menuIdx) {
      if (menuIdx === 'shared') {
        return 'Sharing';
      } else if (menuIdx === 'account') {
        return 'Account';
      } else if (menuIdx === 'BACKUPS') {
        return 'Backup';
      } else if (menuIdx === 'MACHINES') {
        return 'Machines';
      }

      console.log('Undefined menu index', menuIdx);
      return 'Undefined';
    }
  }
};
</script>


<style lang="scss" scoped>

</style>
